import env from 'common/env';

export async function markets() {
    const result = await fetch(`${env}/regie/markets`)
        .then(response => (response.ok ? response.json() : false))
        .then(res => res)
        .catch(error => {
            console.error(error);
        });

    return result;
}
